import { z } from 'zod';

export const IsoDateTime = z.string().datetime({ offset: true });
export const Id = z.string().min(1).max(64);
export const Phone = z.string().regex(/^[0-9]{6,20}$/, 'phone without +');
export const Email = z.string().email();
export const Url = z.string().url();
export const HttpsUrl = z.string().url().startsWith('https://');

export const Currency = z.enum(['USD', 'IQD', 'SAR', 'AED', 'EGP', 'JOD']);
export type Currency = z.infer<typeof Currency>;

export const Paginated = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    items: z.array(item),
    cursor: z.string().nullable(),
    total: z.number().int().nonnegative().optional(),
  });

export const ApiError = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.record(z.unknown()).optional(),
  }),
});
export type ApiError = z.infer<typeof ApiError>;

export const Result = <T extends z.ZodTypeAny>(data: T) =>
  z.union([z.object({ ok: z.literal(true), data }), ApiError]);
